/* Mutation observer to listen for rating elements appearing in product cards. */
(() => {
    const updateSquama = (mutationList) => {
        for (const mutation of mutationList) {
            mutation.addedNodes.forEach((node) => {
                if (
                    node &&
                    node.classList &&
                    (node.classList.contains("spr-badge") ||
                        node.querySelector(".jdgm-prev-badge__stars"))
                ) {
                    const squama = node.closest("squama-item");
                    const rating = parseFloat(node.dataset.rating);

                    if (!squama) return;

                    squama.reinit && squama.reinit(true);
                    squama.dataset.hasRating = rating > 0;
                }
            });
        }
    };

    const startRatingObserver = () => {
        const options = { attributes: false, childList: true, subtree: true };
        const observer = new MutationObserver(updateSquama);
        observer.observe(document.body, options);
    };

    const scheduleObserver = () => {
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(startRatingObserver, { timeout: 1500 });
        } else {
            window.setTimeout(startRatingObserver, 250);
        }
    };

    if (document.readyState === "complete") {
        scheduleObserver();
    } else {
        window.addEventListener("load", scheduleObserver, { once: true });
    }
})();

/* Render rating at product listing after ajax requests */
document.addEventListener("fetcher-update", (event) => {
    if (typeof SPR === "undefined") return;

    SPR.initDomEls();
    SPR.loadBadges();
});
